import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["rootProps", "placeholder", "icon", "color", "height", "h", "minH", "minHeight", "iconColor", "iconSize"],
  _excluded2 = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SelectField } from "./chunk-HQIEHZYI.mjs";

// src/select.tsx
import { useFormControl } from "@chakra-ui/form-control";
import { chakra, forwardRef, layoutPropNames, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { dataAttr } from "@chakra-ui/shared-utils";

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  var picked = {};
  var omitted = {};
  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (keys.includes(key)) picked[key] = value;else omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx
import { cloneElement, isValidElement } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Select = forwardRef(function (props, ref) {
  var _a;
  var styles = useMultiStyleConfig("Select", props);
  var _omitThemingProps = omitThemingProps(props),
    rootProps = _omitThemingProps.rootProps,
    placeholder = _omitThemingProps.placeholder,
    icon = _omitThemingProps.icon,
    color = _omitThemingProps.color,
    height = _omitThemingProps.height,
    h = _omitThemingProps.h,
    minH = _omitThemingProps.minH,
    minHeight = _omitThemingProps.minHeight,
    iconColor = _omitThemingProps.iconColor,
    iconSize = _omitThemingProps.iconSize,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var _split = split(rest, layoutPropNames),
    _split2 = _slicedToArray(_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];
  var ownProps = useFormControl(otherProps);
  var rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color: color
  };
  var fieldStyles = _objectSpread(_objectSpread({
    paddingEnd: "2rem"
  }, styles.field), {}, {
    _focus: _objectSpread({
      zIndex: "unset"
    }, (_a = styles.field) == null ? void 0 : _a["_focus"])
  });
  return /* @__PURE__ */jsxs(chakra.div, _objectSpread(_objectSpread(_objectSpread({
    className: "chakra-select__wrapper",
    __css: rootStyles
  }, layoutProps), rootProps), {}, {
    children: [/* @__PURE__ */jsx(SelectField, _objectSpread(_objectSpread({
      ref: ref,
      height: h != null ? h : height,
      minH: minH != null ? minH : minHeight,
      placeholder: placeholder
    }, ownProps), {}, {
      __css: fieldStyles,
      children: props.children
    })), /* @__PURE__ */jsx(SelectIcon, _objectSpread(_objectSpread(_objectSpread({
      "data-disabled": dataAttr(ownProps.disabled)
    }, (iconColor || color) && {
      color: iconColor || color
    }), {}, {
      __css: styles.icon
    }, iconSize && {
      fontSize: iconSize
    }), {}, {
      children: icon
    }))]
  }));
});
Select.displayName = "Select";
var DefaultIcon = function DefaultIcon(props) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fill: "currentColor",
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
};
var IconWrapper = chakra("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = function SelectIcon(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? /* @__PURE__ */jsx(DefaultIcon, {}) : _props$children,
    rest = _objectWithoutProperties(props, _excluded2);
  var clone = cloneElement(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */jsx(IconWrapper, _objectSpread(_objectSpread({}, rest), {}, {
    className: "chakra-select__icon-wrapper",
    children: isValidElement(children) ? clone : null
  }));
};
SelectIcon.displayName = "SelectIcon";
export { Select, DefaultIcon };